import { Component, OnInit } from '@angular/core'
import { CpmService } from '../../../../service/cpm.service'
import { AuthorizeService } from '../../../../service/authorize.service'
import { ActivatedRoute } from '@angular/router'
import { Subscription } from 'rxjs/Subscription'
import { StoreService } from '../../../../service/store.service'

@Component({
  selector: 'app-full-fact-sheet-business-description',
  templateUrl: './full-fact-sheet-business-description.component.html',
  styleUrls: ['./full-fact-sheet-business-description.component.scss']
})
export class FullFactSheetBusinessDescriptionComponent implements OnInit {
  subscription: Subscription
  text

  constructor(
    private cpmService: CpmService,
    private authorization: AuthorizeService,
    private activatedRoute: ActivatedRoute,
    private store: StoreService
  ) {}

  ngOnInit() {
    const { symbol } = this.activatedRoute.snapshot.params
    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.text = response['businessTypeThai']
      })
  }

  get isUserHasPermission(): Boolean {
    return this.authorization.hasRole('ROLE_USER')
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/full-fact-sheet/full-fact-sheet-page-1/full-fact-sheet-business-description/full-fact-sheet-business-description.component.ts